import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Contact() {
    useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  const navigate = useNavigate();

  return (
    <div style={{ background: '#0A0F1E', minHeight: '100vh', color: 'white', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box' }}>

      {/* Header */}
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 2rem', borderBottom: '1px solid #1a2640' }}>
        <span onClick={() => navigate('/')}
          style={{ color: '#00D4AA', fontWeight: 'bold', fontSize: '1.5rem', cursor: 'pointer' }}>
          CrackPrep
        </span>
        <button onClick={() => navigate(-1)}
          style={{ background: 'transparent', color: '#8899aa', border: '1px solid #1a2640', padding: '0.5rem 1rem', borderRadius: '6px', cursor: 'pointer' }}>
          ← Back
        </button>
      </nav>

      {/* Content */}
      <div style={{ maxWidth: '500px', margin: '0 auto', padding: '6rem 2rem', textAlign: 'center' }}>

        <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>✉️</div>

        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.75rem' }}>
          Contact Us
        </h1>

        <p style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: '2.5rem', fontSize: '1rem' }}>
          Have a question, feedback, or need help with your account? We are here to help.
        </p>

        <div style={{ background: '#141B2D', borderRadius: '12px', padding: '2rem', border: '1px solid #1a2640', marginBottom: '2rem' }}>
          <p style={{ color: '#8899aa', fontSize: '0.85rem', marginBottom: '0.5rem' }}>Email us at</p>
          
        <span
  onClick={() => window.location.href = 'mailto:support@crackprep.in'}
  style={{ color: '#00D4AA', fontSize: '1.2rem', fontWeight: 'bold', textDecoration: 'none', cursor: 'pointer' }}>
  support@crackprep.in
</span>
          <p style={{ color: '#8899aa', fontSize: '0.8rem', marginTop: '1rem', lineHeight: 1.6 }}>
            We typically respond within 24 hours on business days.
          </p>
        </div>

        <button
          onClick={() => navigate('/')}
          style={{ background: 'transparent', color: '#00D4AA', border: '1px solid #00D4AA', padding: '0.75rem 2rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
          Back to Home
        </button>

      </div>

    </div>
  );
}